module.exports = __webpack_public_path__ + "static/bg_small-d9142fede6745045fbc2ab79982bebfb.jpg";